export const E8S_PER_TOKEN = 100_000_000;
export const CHAT_SYMBOL = "CHAT";
export const ICP_SYMBOL = "ICP";
export const BTC_SYMBOL = "BTC";
export const CKBTC_SYMBOL = "ckBTC";
export const SOL_SYMBOL = "SOL";
export const CKSOL_SYMBOL = "ckSOL";
// What the user is charged for a SOL deposit, in lamports, being what they send less what they are
// credited with: more for their first, whose sweep leaves Solana's rent reserve on their address.
// They must match `FIRST_SOL_DEPOSIT_FEE` and `SOL_DEPOSIT_FEE` in the MultiUser canister.
export const FIRST_SOL_DEPOSIT_FEE = 2000000n;
export const SOL_DEPOSIT_FEE = 1000000n;
export const SNS1_SYMBOL = "SNS1";
export const KINIC_SYMBOL = "KINIC";
export const HOTORNOT_SYMBOL = "HOT";
export const GHOST_SYMBOL = "GHOST";
export const USDC_SYMBOL = "USDC";
export const USDT_SYMBOL = "USDT";
export const ETHEREUM_NETWORK = "Ethereum";
export const ARBITRUM_NETWORK = "Arbitrum";
export const BASE_NETWORK = "Base";
export const ONE_SEC_TOKENS = [USDC_SYMBOL, USDT_SYMBOL];
export const LEDGER_CANISTER_ICP = "ryjl3-tyaaa-aaaaa-aaaba-cai";
export const INDEX_CANISTER_ICP = "qhbym-qaaaa-aaaaa-aaafq-cai";
export const LEDGER_CANISTER_CHAT = "2ouva-viaaa-aaaaq-aaamq-cai";
export const LEDGER_CANISTER_CKBTC = "mxzaz-hqaaa-aaaar-qaada-cai";
export const LEDGER_CANISTER_CKETH = "ss2fx-dyaaa-aaaar-qacoq-cai";
export const LEDGER_CANISTER_CKSOL = "ls5lp-lqaaa-aaaar-qb5oa-cai";
export const DEFAULT_TOKENS = ["CHAT", "ICP", "BTC", "USDC", "USDT"];
